import { z } from 'zod';

export const PersonMobileScalarFieldEnumSchema = z.enum(['personmobileId','cityId','personId','mobileType','mobileToken','deviceId']);

export default PersonMobileScalarFieldEnumSchema;
